import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import { Router } from '@angular/router';
import { LoginResponse } from './LoginResponse';
import { User } from './User';
import { CacheService } from 'src/app/shared/services/cache.service';
import { PasswordChangeRequestResponse } from './PasswordChangeRequestResponse';
import { PasswordChangeRequestRequest } from './PasswordChangeRequestRequest';



@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient,
    private configService: ConfigService, 
    private cacheService: CacheService, 
    private router: Router) {
  }


  public login(username: string, password: string): Observable<LoginResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    const tokenParams =
      'username=' + username +
      '&password=' + password +
      '&client_id=' + this.configService.clientId +
      '&client_secret=' + this.configService.clientSecret +
      '&grant_type=password' +
      '&scope=' + this.configService.tokenScope + ' ' + this.configService.refreshTokenScope;

    return this.http.post<LoginResponse>(this.configService.TokenApiUrl, tokenParams, httpOptions)
      .pipe(map(tokenResponse => {
        localStorage.setItem('jwt', tokenResponse.access_token);
        localStorage.setItem('jwt_refresh', tokenResponse.refresh_token);
        return tokenResponse;
      }));
  }

  public refresh_token(): Observable<LoginResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    const refreshToken = localStorage.getItem('jwt_refresh');

    const tokenParams =
      'client_id=' + this.configService.clientId +
      '&client_secret=' + this.configService.clientSecret +
      '&grant_type=refresh_token' +
      '&scope=' + this.configService.refreshTokenScope +
      '&refresh_token=' + refreshToken;
    return this.http.post<LoginResponse>(this.configService.TokenApiUrl, tokenParams, httpOptions)
      .pipe(map(tokenResponse => {
        localStorage.setItem('jwt', tokenResponse.access_token);
        localStorage.setItem('jwt_refresh', tokenResponse.refresh_token);
        return tokenResponse;
      }));
  }

  public logout() {
    this.cacheService.cleanLocalStorage()
    this.router.navigate(['/login']);
  }

  public sendPasswordChangeRequest(request: PasswordChangeRequestRequest): Observable<PasswordChangeRequestResponse> {
    return this.http.post<PasswordChangeRequestResponse>(
      this.configService.UserWebApiUrl + 'ChangePasswordRequest', request);
  }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('jwt');
    if (token == null) {
      return false;
    }

    const claims: any = jwt_decode(token);

    if (Date.now() >= claims.exp * 1000) {
      console.log('token is expired!');
      return false;
    }

    return true;

  }

  public hasRole(roleName:string): boolean{

    const user = this.getLoggedUserInfo();
    return user.userRoles.findIndex( x => x == roleName) > -1
  }

  public hasAbility(abilityName:string): boolean{

    const user = this.getLoggedUserInfo();
    return user.userAbilities.findIndex( x => x == abilityName) > -1
  }

    public hasRestriction(restrictionName:string): boolean{

    const user = this.getLoggedUserInfo();
    return user.userRestrictions?.findIndex( x => x == restrictionName) > -1
  }

  public tokenExpirationTime(): any {
    const token = localStorage.getItem('jwt');

    const claims: any = jwt_decode(this.getToken());
    return new Date(claims.exp *1000);

  }

  public getLoggedUserInfo() :User {

    const claims: any = jwt_decode(localStorage.getItem('jwt'));

    const user = new User();
    user.userData = {
      id : claims.sub,
      name : claims.given_name,
      surname : claims.family_name,
      email : claims.email,
      userName : claims.name,
      phoneNumber : claims.phone_number
    };

    user.userProfilesHashes = claims.profile;
    user.userRoles = claims.roles;
    user.userAbilities = claims.abilities;
    user.userRestrictions = claims.restrictions;

    return user;
  }

  public getToken() {

    return localStorage.getItem('jwt');
  }

  public getSessionKey() {
    if(!localStorage.getItem('jwt'))
    {
      return '';
    }
    const claims: any = jwt_decode(localStorage.getItem('jwt'));
    return claims.sessionKey;
  }

  public getUserKey() {

    const claims: any = jwt_decode(localStorage.getItem('jwt'));
    return claims.userKey;
  }
}






